export default __webpack_public_path__ + "static/media/bx_bxl-redux.9c4390c7.svg";